module.exports = __webpack_public_path__ + "img/9788937490323.3ed7b0bd.jpg";